import { ContentTypes } from 'academy-shared-js/constants/ContentConstants';
export const APP_NAME = 'learning-center';
export const SCREENS = {
  HOME: 'home-page',
  HUBLESS: 'hubless-error-message',
  LESSON: 'lesson',
  LESSONS: 'lessons-dashboard',
  MY_LEARNING: 'my-learning',
  FAVORITES: 'favorites',
  MY_PLAYLISTS: 'my-playlists',
  TEAM: 'team',
  TRACK: 'track',
  TRACKS: 'tracks-dashboard',
  PARTNER: 'partner-tracks-dashboard',
  PLAYLIST: 'playlist',
  WIZARD: 'wizard',
  AUTHENTICATED_COURSE_BROCHURE: 'authenticated-course-brochure'
};
export const SUB_SCREENS = {
  EXAM: 'exam',
  CONCLUSION: 'conclusion',
  RECOMMENDATIONS: 'recommendations'
};
export const TrackingContentTypes = Object.keys(ContentTypes).reduce((obj, key) => {
  const value = key === ContentTypes.PRACTICAL_EXERCISE_FLOW ? 'practical-exercise' : key.toLowerCase();
  return Object.assign({}, obj, {
    [key]: value
  });
}, {});